import { createUniqueGuid } from "./guid";

const uniqueKeyPropertyName = "uniqueKey__identifier_value" as const;

type ObjectWithUniqueKey<T> = T & {
    [uniqueKeyPropertyName]?: string;
};

export function setUniqueKeyOrNew<T extends object>(
    obj: T,
    value: string | undefined | null
) {
    if (value != null && value.length > 0) {
        return setUniqueKey(obj, value);
    } else {
        return renewUniqueKey(obj);
    }
}

export function setUniqueKey<T extends object>(obj: T, value: string) {
    const keyedObj = obj as ObjectWithUniqueKey<T>;
    keyedObj[uniqueKeyPropertyName] = value;
    return keyedObj[uniqueKeyPropertyName];
}

export function getExistingUniqueKey<T extends object>(obj: T) {
    const keyedObj = obj as ObjectWithUniqueKey<T>;
    return keyedObj[uniqueKeyPropertyName];
}

export function ensureUniqueKey<T extends object>(obj: T) {
    return getExistingUniqueKey(obj) ?? renewUniqueKey(obj);
}

export function renewUniqueKey<T extends object>(obj: T) {
    return setUniqueKey(obj, createUniqueGuid() as string);
}

export function applyUniqueKeyToObject<T extends object>(obj: T) {
    ensureUniqueKey(obj);
    return obj;
}
